var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_1148)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7151 16.0595L6.90142 10.6237L2.12721 16.0595H0.107422L6.00532 9.34619L0.107422 0.940796H5.29311L8.88743 6.064L13.3909 0.940796H15.4107L9.78654 7.34322L15.9008 16.0595H10.7151ZM12.9643 14.5271H11.6045L2.99946 2.47329H4.35946L7.80585 7.29971L8.40182 8.13722L12.9643 14.5271Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_1148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4932,
    height: 16.4932,
    fill: "white",
    transform: "translate(0.00390625 0.500122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.85e77dccbe1130adba46ecde4a8998cd.svg";
export { ForwardRef as ReactComponent };